import axios from 'axios'
import Vue from 'vue';

const state = {
    groupements: [],
    article: {},
    colors: [],
    socle: {},
    Ref_article: {},
    articleLoading: false
}

const getters = {
    groupements: state => state.groupements,
    article: state => state.article,
    colors: state => state.colors,
    socle: state => state.socle,
    Ref_article: state => state.Ref_article,
    articleLoading: state => state.articleLoading
}


const actions = {

    getArticleByCode({
        commit
    }, CodeArticle) {
        commit('setArticleLoading', true)
        return new Promise((resolve, reject) => {
            axios.get('/api/getArticleByCode/' + CodeArticle).then(response => {
                commit('setArticleLoading', false)
                commit('setArticle', response.data);
                resolve(response);
            }).catch(error => {
                commit('setArticleLoading', false)
                reject(error);
            });
        });
    },

    getArticleByRef({
        commit
    }, RefArticle) {
        commit('setArticleLoading', true)
        return new Promise((resolve, reject) => {
            axios.get('/api/getArticleByRef/' + RefArticle).then(response => {
                commit('setArticleLoading', false)
                commit('setRef_article', response.data);
                resolve(response);
            }).catch(error => {
                commit('setArticleLoading', false)
                reject(error);
            });
        });
    },

    getSocleByCode({
        commit
    }, CodeSocle) {
        return new Promise((resolve, reject) => {
            axios.get('/api/getArticleByCode/' + CodeSocle).then(response => {
                commit('setSocle', response.data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },

  getColorByArticle({
    commit
    },CodeArticle) {
    return new Promise((resolve, reject) => {
        axios.get('/api/getColorByArticle/' + CodeArticle).then(response => {
          // Ajout de la couleur "panachage" par défaut
          let colors = response.data
          if (state.article.LG_ListeCouleur != '' && state.article.LG_ListeCouleur != null && state.article.LG_ListeCouleur.length > 1) {
            colors.unshift({text:'Panachage',value:''})
          }
          commit('setColors', colors);
          resolve(response);
        }).catch(error => {
            reject(error);
        });
      });
    },

    getGroupements({
        commit
    }) {
        return new Promise((resolve, reject) => {
            axios.get('/api/groupements').then(response => {
                commit('setGroupements', response.data)
                resolve(response)
            }).catch(error => {
                reject(error);
            });
        });
    },
}

const mutations = {
    setGroupements(state, groupements) {
        state.groupements = groupements
    },
    setArticle(state, article) {
        state.article = article
    },
    setColors(state, colors) {
        state.colors = colors
    },
    resetColors(state) {
        state.colors = []
    },
    setSocle(state, socle) {
        state.socle = socle
    },
    setRef_article(state, Ref_article) {
        state.Ref_article = Ref_article
    },
    setArticleLoading(state, articleLoading) {
        state.articleLoading = articleLoading
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
